import type {
  PerformanceDataResponse,
  StrategiesListResponse,
  Strategy,
  StrategyFilters,
} from "@/types/api.types";
import {
  API_BASE_URL,
  buildQueryString,
  fetchWithTimeout,
  handleResponse,
} from "./shared";

// ============================================================================
// Strategy API
// ============================================================================

export const strategiesApi = {
  /**
   * List all strategies with optional filters
   */
  async list(filters?: StrategyFilters): Promise<StrategiesListResponse> {
    const queryParams = filters
      ? {
          marketView: filters.marketView,
          riskLevel: filters.riskLevel,
          assetClass: filters.assetClass,
          sortBy: filters.sortBy,
          sortOrder: filters.sortOrder,
        }
      : undefined;

    const queryString = buildQueryString(queryParams);
    const response = await fetchWithTimeout(
      `${API_BASE_URL}/api/strategies${queryString}`
    );
    return handleResponse<StrategiesListResponse>(response);
  },

  /**
   * Get a single strategy by ID
   */
  async get(id: string): Promise<Strategy> {
    const response = await fetchWithTimeout(`${API_BASE_URL}/api/strategies/${id}`);
    return handleResponse<Strategy>(response);
  },

  /**
   * Get strategy performance history
   */
  async getPerformance(id: string, days = 365): Promise<PerformanceDataResponse> {
    const response = await fetchWithTimeout(
      `${API_BASE_URL}/api/strategies/${id}/performance?days=${days}`
    );
    return handleResponse<PerformanceDataResponse>(response);
  },
};
